import { z } from 'zod';
import { meetingLanguageSchema, meetingSourceSchema, meetingStatusSchema, meetingTypeSchema, uploadStateSchema, } from './enums.js';
export const attendeeInputSchema = z.object({
    userId: z.string().nullish(),
    externalName: z.string().min(1).max(200).nullish(),
    roleInMeeting: z.string().max(120).nullish(),
    speakerLabel: z.string().max(60).nullish(),
});
export const createMeetingInputSchema = z.object({
    type: meetingTypeSchema,
    title: z.string().min(1).max(300),
    startedAt: z.coerce.date().optional(),
    location: z.string().max(200).nullish(),
    departmentId: z.string().nullish(),
    clientRef: z.string().max(120).nullish(),
    leadRef: z.string().max(120).nullish(),
    language: meetingLanguageSchema.default('BOTH'),
    source: meetingSourceSchema.default('IN_PERSON'),
    attendees: z.array(attendeeInputSchema).max(50).default([]),
});
export const updateMeetingInputSchema = createMeetingInputSchema
    .partial()
    .extend({ status: meetingStatusSchema.optional() });
export const meetingListQuerySchema = z.object({
    type: meetingTypeSchema.optional(),
    status: meetingStatusSchema.optional(),
    dateFrom: z.coerce.date().optional(),
    dateTo: z.coerce.date().optional(),
    departmentId: z.string().optional(),
    q: z.string().max(200).optional(),
    take: z.coerce.number().int().min(1).max(200).default(50),
    skip: z.coerce.number().int().min(0).default(0),
});
export const attendeeSchema = z.object({
    id: z.string(),
    userId: z.string().nullable(),
    externalName: z.string().nullable(),
    roleInMeeting: z.string().nullable(),
    speakerLabel: z.string().nullable(),
});
export const meetingSchema = z.object({
    id: z.string(),
    type: meetingTypeSchema,
    title: z.string(),
    startedAt: z.string(),
    durationSec: z.number().nullable(),
    location: z.string().nullable(),
    departmentId: z.string().nullable(),
    clientRef: z.string().nullable(),
    leadRef: z.string().nullable(),
    status: meetingStatusSchema,
    failureDetail: z.string().nullable(),
    language: meetingLanguageSchema,
    source: meetingSourceSchema,
    createdById: z.string(),
    retentionAt: z.string().nullable(),
    attendees: z.array(attendeeSchema).default([]),
});
export const recordingSchema = z.object({
    id: z.string(),
    meetingId: z.string(),
    objectKey: z.string(),
    format: z.string(),
    durationSec: z.number().nullable(),
    sizeBytes: z.number().nullable(),
    uploadState: uploadStateSchema,
    attempt: z.number().int().default(0),
    chunkCount: z.number().default(0),
});
export const startRecordingResponseSchema = z.object({
    recordingId: z.string(),
    meetingId: z.string(),
    attempt: z.number().int(),
    objectKeyPrefix: z.string(),
});
export const startRecordingInputSchema = z.object({
    restart: z.boolean().default(false),
});
/**
 * `totalChunks` is what the recorder actually produced. It is required: without
 * it the server cannot tell a short upload from a complete one.
 */
export const completeRecordingInputSchema = z.object({
    totalChunks: z.number().int().min(1),
    durationSec: z.number().min(0).optional(),
});
//# sourceMappingURL=meetings.js.map